/*
 *    Copyright [2007-2025] [wisemapping]
 *
 *   Licensed under WiseMapping Public License, Version 1.0 (the "License").
 *   It is basically the Apache License, Version 2.0 (the "License") plus the
 *   "powered by wisemapping" text requirement on every single page;
 *   you may not use this file except in compliance with the License.
 *   You may obtain a copy of the license at
 *
 *       https://github.com/wisemapping/wisemapping-open-source/blob/main/LICENSE.md
 *
 *   Unless required by applicable law or agreed to in writing, software
 *   distributed under the License is distributed on an "AS IS" BASIS,
 *   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *   See the License for the specific language governing permissions and
 *   limitations under the License.
 */

import React from 'react';
import { useIntl } from 'react-intl';
import AsyncButton from '../async-button';

type SubmitButtonProps = {
  value: string;
  disabled?: boolean;
  isLoading?: boolean;
};

const SubmitButton = ({ value, disabled, isLoading }: SubmitButtonProps): React.ReactElement => {
  const intl = useIntl();

  const loadingText = intl.formatMessage({ id: 'common.wait', defaultMessage: 'Please wait ...' });

  return (
    <AsyncButton
      color="primary"
      size="medium"
      variant="contained"
      type="submit"
      disableElevation={true}
      disabled={disabled}
      isLoading={isLoading}
      loadingText={loadingText}
      style={{
        width: '300px',
        height: '53px',
        padding: '0px 20px',
        margin: '7px 0px',
        fontSize: '18px',
      }}
    >
      {value}
    </AsyncButton>
  );
};

export default SubmitButton;
